export const getOrDefault = (value, default_value) => {
  return value ? value : default_value;
};
